import { render, staticRenderFns } from "./SearchCourse.vue?vue&type=template&id=1f98dc6d&scoped=true"
import script from "./SearchCourse.vue?vue&type=script&lang=js"
export * from "./SearchCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f98dc6d",
  null
  
)

export default component.exports